import { Api } from "../axios-config";
import { ISetor } from "../setor/SetorService";
import { IListagemTipo, ITipo } from "../tipo/TipoService";

export interface IPesquisaPermissao {
    unidade: [
        {
            idUnidade: number,
            nomeUnidade: string,
        }
    ],
    setor: [
        {
            idSetor: number,
            nomeSetor: string,
        }
    ],
    tipo: number[],
    indice: number[]
}

const getTipos = async (idSetor: number) => {
    try {

        const { data } = await Api.get(`Tipo/idSetor?idSetor=${idSetor}`);

        if (data) {
            var dados: Array<{ idTipo: number, nomeTipo: string, idTipoPai: number, nivel: number, idSetor: number, tipo_indices: Array<any> }> = [];
            //@ts-expect-error
            data.map(row => {
                dados.push(
                    {
                        'idTipo': row.idTipo,
                        'idTipoPai': row.idTipoPai,
                        'nomeTipo': row.nomeTipo,
                        'nivel': row.nivel,
                        'idSetor': row.idSetor,
                        'tipo_indices': row.tipo_indices
                    },
                    );
                })
            
            const idMapping = dados.reduce((acc, el, i) => {
                //@ts-expect-error
                acc[el.idTipo] = i;
                return acc;
            }, {});

            let raiz: IListagemTipo[] = [];
            dados.forEach((el) => {
                // Pega o elemento que não tem pai
                if (el.idTipoPai === null) {
                    //@ts-expect-error
                    raiz = [...raiz, el];
                    return;
                }
                //@ts-expect-error // Usa o map para locailizar o elemento pai
                const parentEl = dados[idMapping[el.idTipoPai]];
                //@ts-expect-error // Adiciona o elemento atual para o `tipos`do pai
                parentEl.tipos = [...(parentEl.tipos || []), el];
            });
            return {
                raiz,
                data
            };
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const create = async (idPerfil: number, dados: number[]): Promise<String | Error> => {
    try {

        const { data } = await Api.post(`Permissao?idPerfil=${idPerfil}`, dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getByIdPerfil = async (idPerfil: number): Promise<IPesquisaPermissao | Error> => {
    try {
        const { data } = await Api.get(`Permissao/pesquisarTiposBloqueados?idPerfil=${idPerfil}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const getSetoresByIdsUndidade = async (ids: number[]): Promise<ISetor[] | Error> => {
    try {
        var url = `Setor/idsUnidade?estado=true&`;
        ids.map((id, index) => {
            url += `idsUnidade=${id}`;
            if (index !== ids.length - 1) {
                url += "&";
            }
        });
        const { data } = await Api.get(url);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

export const PermissaoService = {
    getTipos,
    create,
    getByIdPerfil,
    getSetoresByIdsUndidade,
}